import React from "react";

const Service = (props) => {

    return <section className="content">
        <h3>{ props.title }</h3>
        <p>{ props.content }</p>
        {/* {
            props.content.map((item) => {
                return <p>
                    {item}
                </p>
            })
        } */}
    </section>
}

Service.defaultProps = {
    
};

export default Service